export const wrapBoldTranslationChunks = chunks => <b>{chunks}</b>;
